import { render, staticRenderFns } from "./HeaderMappingEdit.vue?vue&type=template&id=0e036bc8&scoped=true&"
import script from "./HeaderMappingEdit.vue?vue&type=script&lang=js&"
export * from "./HeaderMappingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e036bc8",
  null
  
)

export default component.exports